import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SharedLibModule } from '../../shared.module';
import { LoaderComponent } from '../loader/loader.component';
import { HttpErrorResponse } from '@angular/common/http';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TextAreaModule, TextBoxModule, UploaderComponent, UploaderModule } from '@syncfusion/ej2-angular-inputs';
import { RichTextEditor } from '@syncfusion/ej2-angular-richtexteditor';
// import { AddFilesPopupComponent } from 'projects/sales/src/app/shared/components/proposal-doc-files-popup/add-files-popup/add-files-popup.component';
// import { CommonService } from 'projects/sales/src/app/shared/services/common.service';
import { forkJoin } from 'rxjs';
import { ModuleNames } from '../../models/lib.model';
import { PopupHeaderComponent } from '../popup-header/popup-header.component';
import { environment } from 'projects/service/src/environments/environment';
import { MasterItemcodePopupService } from './master-itemcode-popup.service';
import { CommonService } from 'projects/service/src/app/shared/services/common.service';
const BASE_URL = environment.masterApiURL;
const token = localStorage.getItem('access_token');

@Component({
    imports: [CommonModule, LoaderComponent, SharedLibModule, TextBoxModule, TextAreaModule, UploaderModule, ReactiveFormsModule, PopupHeaderComponent],
    selector: 'app-master-itemcode-popup',
    templateUrl: './master-itemcode-popup.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./master-itemcode-popup.component.scss']
})
export class MasterItemcodePopupComponent implements OnInit {

    
      @ViewChild('attachmentUpload') public uploadObj!: UploaderComponent;
      @ViewChild('imageChooser') imageChooser!: ElementRef;
      @ViewChild('pdfChooser') pdfChooser!: ElementRef;
      @ViewChild('rteItemInfoSetup') rteItemInfoSetup!: RichTextEditor;
      @ViewChild('itemImageUpload') public itemImageUpload!: UploaderComponent;
      @ViewChild('pdfUpload') public pdfUpload!: UploaderComponent;
    
      public path: Object = {
        saveUrl: `${BASE_URL}FileManagement/UploadTemp`,
        removeUrl: 'https://ej2.syncfusion.com/services/api/uploadbox/Remove'
      };
      originalPopupSnapshot: any;
      public dropElement: HTMLElement = document.getElementsByClassName('droparea')[0] as HTMLElement;
      public pdfDropArea: HTMLElement = document.getElementById('pdf-upload') as HTMLElement;
      public tools: object = {
        items: [
          'Undo', 'Redo',
          'Bold', 'Italic', 'Underline', 'StrikeThrough', '|',
          'FontSize', 'FontColor',
          'LowerCase', 'UpperCase', '|',
          'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
          'Indent', 'Outdent', '|', 'CreateLink', '|',
          'Image', 'ClearFormat', '|'
        ], overflowMode: 'Extended'
      };
      // public iframe: object = { enable: true };
      public height: number = 350;
      public mainHeight: number = window.innerHeight - 400;
      channelsDDL: any;
      accountsDDL: any;
      showLoader: boolean = true;
      // The item could not be read: the popup says so instead of spinning forever.
      loadFailed = false;
      private readonly cdr = inject(ChangeDetectorRef);
      blankImage = "assets/img/blank.jpg"
      element: HTMLElement | undefined;
      isMaximized: boolean = true;
      itemInfoSetupForm!: any;
      toSendimageUrl: any;
      toSendPdfUrl: any;
      imageUrl: any;
      public imageSrc: any;
      public pdfSelected: string | ArrayBuffer | null = null;
      dataSource: any;
      popupData: any;
      selectedFiles: any = [];
      showAllChannels = false;
      showAllAccounts = false;
    
      permissionNames = ItemInfoSetupPermissions;
      flyerURL: any;
      productURL: any;
      rolePermissions: any = {}
      status: any;
    
      constructor(private commonService: CommonService, private itemInfoService: MasterItemcodePopupService, private formBuilder: FormBuilder,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialog: MatDialog,
        public dialogRef: MatDialogRef<any>) {
        this.createForm();
      }
    
      ngOnInit() {
        this.showLoader = true;
        this.loadaAPIs();
      }
      getPopupSnapshot() {
        const channelValue = Array.isArray(this.itemInfoSetupForm?.value?.channel)
          ? [...this.itemInfoSetupForm.value.channel].sort()
          : this.itemInfoSetupForm?.value?.channel;
    
        const accountValue = Array.isArray(this.itemInfoSetupForm?.value?.account)
          ? [...this.itemInfoSetupForm.value.account].sort()
          : this.itemInfoSetupForm?.value?.account;
    
        return {
          item: this.dataSource?.item ?? '',
          channel: channelValue ?? [],
          account: accountValue ?? [],
          itemDescription: this.itemInfoSetupForm?.value?.itemDescription ?? '',
          flyerURL: this.itemInfoSetupForm?.value?.flyerURL ?? '',
          productURL: this.itemInfoSetupForm?.value?.productURL ?? '',
          productSpecification: this.itemInfoSetupForm?.value?.productSpecification ?? '',
          brochure: this.toSendPdfUrl || this.dataSource?.brochureURL || '',
          image: this.toSendimageUrl || this.dataSource?.imageURL || '',
          addtFiles: Array.isArray(this.selectedFiles)
            ? [...this.selectedFiles].sort()
            : [],
          status: this.status ?? ''
        };
      }
      createForm() {
        this.itemInfoSetupForm = this.formBuilder.group({
          channel: ['', Validators.required],
          account: ['', Validators.required],
          brouschre: [''],
          flyerURL: [''],
          image: [''],
          item: [],
          itemDescription: [''],
          itemDescriptionLN: [''],
          productURL: [''],
          productSpecification: [''],
        });
      }
    
      loadaAPIs() {
        // this.showLoader = true;
        const apis = [
          this.itemInfoService.getAllChannels(ModuleNames.itemInfoSetup),
          this.itemInfoService.getAccountsByItem(this.data.item || this.data.itemCode),
          this.itemInfoService.getItemDetailsById(this.data.item || this.data.itemCode)
        ]
        forkJoin(apis).subscribe((res: any) => {
          this.channelsDDL = res[0]?.result;
          this.accountsDDL = res[1]?.result;
          this.dataSource = res[2]?.result;
          this.popupData = JSON.stringify(res[2].result);
          this.status = res[2].result?.status;
          this.selectedFiles = res[2].result?.addtFiles;
          this.getRolePermission();
          this.setValues();
    
          setTimeout(() => {
            this.originalPopupSnapshot = JSON.stringify(this.getPopupSnapshot());
          });
        }, (error: HttpErrorResponse) => {
          console.error('Item information could not be loaded', error);
          this.loadFailed = true;
          this.showLoader = false;
          // OnPush (the Angular 22 default): an HTTP callback does not redraw the view by itself.
          this.cdr.markForCheck();
        })
      }
    
      getRolePermission() {
        this.itemInfoService.getRolePermission(PermissionModuleName.infoSetupPopup).subscribe((res: any) => {
          res.result.forEach((rule: any) => {
            this.itemInfoService.rolePermissions[rule.ruleAction] = {
              visible: rule.visible,
              readOnly: rule.readOnly,
              enable: rule.enable,
            }
          });
          this.rolePermissions = this.itemInfoService.rolePermissions;
          this.showLoader = false;
        }, (error: HttpErrorResponse) => {
          this.showLoader = false;
          this.cdr.markForCheck();
          throw error;
        });
      }
    
    
      setValues() {
        const data = this.dataSource;
        const controls = this.itemInfoSetupForm.controls;
        if (this.data.item || this.data.itemCode) {
          controls['flyerURL'].setValue(data?.flyerURL);
          if (data.account) {
            controls['account'].setValue(data?.account?.split(',').map((item: any) => item.trim()));
          }
          if (data.channel) {
            controls['channel'].setValue(data?.channel?.split(',').map((item: any) => item.trim()));
          }
          controls['productURL'].setValue(data?.productURL);
          controls['itemDescription'].setValue(data?.itemDescription);
          controls['productSpecification'].setValue(data?.productSpecification);
          controls['brouschre'].setValue(data?.brochureURL);
        }
        controls['channel'].markAsTouched();
        controls['account'].markAsTouched();
      }

      get channelPills(): string[] {
        return this.getSelectedPills('channel', this.channelsDDL);
      }

      get accountPills(): string[] {
        return this.getSelectedPills('account', this.accountsDDL);
      }

      private getSelectedPills(controlName: string, options: any[]): string[] {
        const value = this.itemInfoSetupForm?.get(controlName)?.value;
        const selectedValues = Array.isArray(value)
          ? value
          : typeof value === 'string' && value.trim()
            ? value.split(',').map(item => item.trim())
            : [];

        return selectedValues
          .filter(item => item !== null && item !== undefined && String(item).trim().length > 0)
          .map(item => {
            const option = options?.find(option => String(option?.value) === String(item));
            return option?.text || String(item);
          });
      }
    
    
    
      showImageBlobInProfilePicture(fileUrl: string, imageType: string) {
        if (fileUrl) {
          let url = `${BASE_URL}FileManagement/UploadTemp?fileUrl=${fileUrl}`
          fetch(url, {
            headers: new Headers({
              'Origin': location.origin
            }),
            mode: 'cors'
          })
            .then(response => response.blob())
            .then(blob => {
              (document.getElementById(imageType == 'UserProfilePic' ? 'profilePicturePlaceholder' : 'logoPlaceholder') as HTMLImageElement).src = URL.createObjectURL(new Blob([blob]));
              this.showLoader = false;
            })
            .catch(e => {
              console.error(e);
              this.showLoader = false;
            });
          this.showLoader = false;
        } else {
          this.showLoader = false;
        }
      }
    
      public setGridHeight(isMaximized: boolean) {
        this.rteItemInfoSetup?.refresh();
        if (window.innerWidth < 1650) {
          if (isMaximized) {
            this.mainHeight = window.innerHeight - 350;
          } else {
            this.mainHeight = window.innerHeight - 480;
          }
        } else {
          if (isMaximized) {
            this.mainHeight = window.innerHeight - 350;
          } else {
            this.mainHeight = window.innerHeight - 520;
          }
        }
      }
    
      beforeFileUpload(args: any, type: any) {
        this.showLoader = true;
        if (args.fileData.name.length > 250) {
          this.commonService.showNotification("error", "File name too long")
          args.cancel = true;
          this.showLoader = false;
        } else if (type !== fileType.pdf && args.fileData.size > 4300000) {
          this.commonService.showNotification("error", "Image size cannot be greater than 4mb")
          args.cancel = true;
          this.showLoader = false;
        } else if (type != fileType.pdf && !(['jpg', 'jpeg', 'png', 'bmp', 'webp', 'svg', 'tiff', 'tif', 'heic', 'heif', 'avif'].includes(args.fileData.type))) {
          this.commonService.showNotification("error", "Please upload a valid image file (PNG, JPG, JPEG, BMP, WEBP, SVG, TIFF, HEIC, HEIF, AVIF).")
          args.cancel = true;
          this.showLoader = false;
        } else if (type === fileType.pdf && args.fileData.type !== fileType.pdf ) {
          args.cancel = true;
          this.showLoader = false;
          this.commonService.showNotification("error", "Document with only pdf format is allowed.")
        }
        else {
          args?.currentRequest?.setRequestHeader('Authorization', `Bearer ${token}`);
        }
      }
    
      onProgress(args: any): void {
        this.showLoader = true;
        const progressElement = args.fileData?.progressWrapper;
        if (progressElement) {
          if (progressElement) {
            progressElement.style.display = 'none';
            progressElement.style.height = '0';
            progressElement.style.margin = '0';
            progressElement.style.padding = '0';
          }
        }
      }
    
      openInNewTab(event: any, type: any) {
        event.preventDefault();
        if (type === 'flyer') {
          const flyerURL = this.itemInfoSetupForm.get('flyerURL').value;
          if (flyerURL) {
            window.open(flyerURL, '_blank');
          }
        } else {
          const productURL = this.itemInfoSetupForm.get('productURL').value;
          if (productURL) {
            window.open(productURL, '_blank');
          }
        }
    
      }
    
      // openSelectItemsPopup(details?: any) {
    
      //     const dialogRef = this.dialog.open(AddFilesPopupComponent, {
      //       backdropClass: 'no-backdrop',
      //       disableClose: true,
      //       maxWidth: '100vw',
      //       maxHeight: '100vh',
      //       width: '100%',
      //       height: '100%',
      //       enterAnimationDuration: '0',
      //       exitAnimationDuration: '0',
      //       data: {
      //           docsFileData: this.selectedFiles,
      //           title: 'Select Files',
      //           isMaximized: true,
      //           module: 'itemInfoSetup',
      //           primaryId: '',
      //           status: this.data.status,
      //           showExisting: this.data.showExistingDocs,
      //           skipGenerateReports: true
      //       },
      //       })
      //       dialogRef.afterClosed().subscribe((result) => {
      //           if(result) {
      //               this.selectedFiles = result;
      //               this.selectedFiles = result?.map(item => item.fileId);
      //           }
      //     });
    
    
    
      //   }
    
      onCloseClick() {
        if (this.loadFailed || !this.isChanged()) {
          this.dialogRef.close();
          return;
        }
        this.commonService.showConfirmation('Are you sure? Unsaved changes will be discarded!')
          .then(result => {
            if (result.isConfirmed) {
              this.dialogRef.close();
            }
          });
      }
    
      isChanged() {
        const currentSnapshot = JSON.stringify(this.getPopupSnapshot());
        return this.originalPopupSnapshot !== currentSnapshot;
      }
    
      getPdfUpload(e: Event) {
        this.showLoader = false;
        (document.querySelector(`#pdfUpload > div > div > button`) as HTMLButtonElement)
          .click();
        e.preventDefault();
        e.stopPropagation();
      }
    
      downloadFile(url) {
        window.open(url, '_blank');
      }
    
    }
    
export enum saveBtn {
    save = 'save',
    saveAndClose = 'saveAndClose',
    saveAndActivate = 'saveAndActivate',
    saveAndDeactivate = 'saveAndDeactivate'
}

export enum ItemInfoSetupPermissions {
    massUpdate = 'itemInfoSetupPopup_massUpdateIcon',
    channel = 'itemInfoSetupPopup_details_channel',
    account = 'itemInfoSetupPopup_details_account',
    description = 'itemInfoSetupPopup_details_description',
    flyerURL = 'itemInfoSetupPopup_details_flyerURL',
    productURL = 'itemInfoSetupPopup_details_productURL',
    brochure = 'itemInfoSetupPopup_details_brochure',
    image = 'itemInfoSetupPopup_details_image',
    productSpec = 'itemInfoSetupPopup_details_productSpecs',
    btns = 'itemInfoSetupPopup_details_btns'
}

export enum fileType {
    image = 'image',
    pdf = 'pdf'
}

export enum PermissionModuleName {
    infoSetupPopup = 'itemInfoSetupPopup',
}